import { configureStore } from '@reduxjs/toolkit';

import rtkQueryErrorLogger from './rtkQueryErrorLogger';
import { apiService } from './api';
import user from './user';

const store = configureStore({
  reducer: {
    [apiService.reducerPath]: apiService.reducer,
    [user.name]: user.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([rtkQueryErrorLogger, apiService.middleware]),
});

export const resetAllApiState = () => {
  store.dispatch(apiService.util.resetApiState());
};

export default store;

export type RootState = ReturnType<typeof store.getState>;
